import {Component} from "react";
import RequestPhonePin from "./RequestPhonePin";
import {Button, Card, FormText, Form} from "react-bootstrap";
import NoPin from "./NoPin";
import {Home} from "../../config/Routes";
import {Redirect} from "react-router-dom";
import {toast} from "react-toastify";

export interface EnterPhonePinProps {
    pin: string
    changePin: (pin: string) => void
    submitPin: () => void
    userName?: string
}
export interface EnterPhonePinState {
    goHome: boolean
}
export default class EnterPhonePin extends Component<EnterPhonePinProps, EnterPhonePinState> {

    state: EnterPhonePinState ={
        goHome: false
    }

    doesPinLookValid = (): boolean => {
        if(this.props.pin && this.props.pin.length === 6){
            const pinNumberFound = parseInt(this.props.pin);
            return !isNaN(pinNumberFound);
        }
        return false;
    }

    submitPin = () => {
        if(this.doesPinLookValid()){
            this.props.submitPin();
        }else{
            toast.error("PIN Appears To Be Invalid!");
        }
    }

    render() {
        return <>
            <div className="col d-flex justify-content-center">
                {this.state.goHome && <Redirect to={Home} /> }
                <Card style={{ width: '60rem' }}>
                    <Card.Header>ENTER COMMUNICATED PIN <div className="float-right"><NoPin /></div></Card.Header>
                    <Form onSubmit={(e)=>{e.preventDefault();this.submitPin()}}>
                        <Card.Body>
                            <FormText>
                                <Form.Group className="mb-3" controlId="frmBasicPin">
                                    <Form.Control autoFocus={true}  value={this.props.pin}
                                                  onChange={(e) => {this.props.changePin(e.target.value)}}
                                                  type="text" placeholder="Numeric Pin" />
                                </Form.Group>
                            </FormText>
                            <RequestPhonePin resend={true} skinny={true} userName={this.props.userName}/>
                        </Card.Body>
                        <Card.Footer>
                            <Button className="m-2" variant='outline-secondary' onClick={() => {this.setState({goHome: true})}}>
                                Return Home
                            </Button>
                            <Button type="submit" className="float-right" variant='primary'>
                                Submit Pin
                            </Button>
                        </Card.Footer>
                    </Form>
                </Card>
            </div>
        </>
    }
}
